import { Component, OnInit } from '@angular/core';
import { AuthService, DataService } from 'src/app/services';
import {FOOTER_Privacy_Nav, FOOTER_ABOUT_NAV, FOOTER_TRAVEL_HELP_NAV, FOOTER_TOUCH_NAV, FOOTER_QUICK_NAV, FOOTER_INFORMATION_NAV, FOOTER_HOTEL_INFORMATION_NAV, FOOTER_VISA_INFORMATION_NAV } from '../../constants/navigation';
import { Router } from '@angular/router';
declare var require: any;

@Component({
  selector: 'app-auth-footer',
  templateUrl: './auth-footer.component.html',
  styleUrls: ['./auth-footer.component.scss']
})
export class AuthFooterComponent implements OnInit {
  today = new Date();
  footerInformatin; // Define footerInformatin property
  footerImage = 'assets/belairtrip_assets/main/belairtrip_white.svg';
  itaIcon = this.data.itaIcon;
  paymentIcon = this.data.paymentIcon;
  socialMedia = this.data.socialMedia;
  // privacyPolicy = this.data.privacyPolicy;
  privacyPolicy = FOOTER_Privacy_Nav;
  aboutItem = FOOTER_ABOUT_NAV;
  travelItem = FOOTER_TRAVEL_HELP_NAV;
  // flightItem = this.footerInformatin;
  quickItem = FOOTER_QUICK_NAV;
  touchItem = FOOTER_TOUCH_NAV;
  travelInfoName: any;
  isLoggedIn = false;

  constructor(private data: DataService, private auth: AuthService, private router: Router) {
    // Set isLoggedIn based on the authentication status
    this.isLoggedIn = this.auth.loggedIn() ? true : false; // Assuming you want true if logged in

    // Split the window location path
    const windowsPath = window.location.pathname.split('/');

    // Determine the base path based on login status
    let basePath: string;
    if (this.isLoggedIn) {
      basePath = `${windowsPath[1]}/${windowsPath[2] || ''}`; // Use windowsPath[2] if available, otherwise windowsPath[1]
    } else {
      basePath = windowsPath[1];
    }
    
    // Determine footer information and travel info name based on basePath
    if (basePath === 'b2c' || basePath === 'u/b2c') {
      this.travelInfoName = 'Flight';
      this.footerInformatin = FOOTER_INFORMATION_NAV;
    } 
    // else if (basePath === 'hotel' || basePath === 'u/hotel') {
    //   this.travelInfoName = 'Hotel';
    //   this.footerInformatin = FOOTER_HOTEL_INFORMATION_NAV;
    // } else if (basePath === 'visa' || basePath === 'u/visa') {
    //   this.travelInfoName = 'Visa';
    //   this.footerInformatin = FOOTER_VISA_INFORMATION_NAV;
    // } 
    else {
      this.travelInfoName = 'Flight';
      this.footerInformatin = FOOTER_INFORMATION_NAV;
    }
  }

  ngOnInit(): void {  }

  navigateToPath(path: string, isLoggedIn: boolean): void {
    const fullPath = isLoggedIn ? `./u/${path}` : `../${path}`;
    this.router.navigate([fullPath]);
  }
}
